import './polyfills';
import {isStorageEnabled, isCapableStoreAndHoldCookies} from './utils/checks';
import {demoMode} from './utils/urlParams';
import {autoOpen} from './utils/scriptParams';
import {isWebview} from './utils/webview';
import {config, foreignCookie, start, initSentry, end} from './services/measurement';
import {USER_EXT} from './constants';
import setPublicAPI from './publicAPI';
import {userHasConsentCookie, userNoConsentCookie, openImmediately} from './services/cmp';
import {isForeignEuconsent, existsConsentCookie} from './services/consent';
import {copyTcf2FromGlobalStorage} from './services/cmp2';
import {logger} from './services/logger';
import {initRedirect, shouldRedirect} from './services/redirect';

const body = document.querySelector('body'); // Cypress setting data attributes according to cmp actions

const openExternalImmediately = openImmediately(USER_EXT);
/**
 * Decides whether to open the dialog, rewrites browser cookie etc..
 */
const initCMP = async () => {
  config(USER_EXT);

  /* Temporary for switching to CMP2 */
  const tcf2Copied = await copyTcf2FromGlobalStorage(USER_EXT);

  if (tcf2Copied) {
    // TCF2.0 successfully copied to local domain
    end();
    return;
  }
  /* end of temporary switching to CMP2 */

  if (!isCapableStoreAndHoldCookies) {
    logger(200, 'Cannot store and hold cookies');
    return;
  }

  if (existsConsentCookie()) {
    if (isForeignEuconsent()) {
      window.scmp.sznCookie = false;
      foreignCookie();
      logger(201, 'Foreign euconsent cookie found in local domain.');
      body.setAttribute('data-cy-cmp-done', 'true');
      return;
    }
    window.scmp.sznCookie = true;

    logger(202, 'Seznam euconsent cookie found in local domain.');
    await userHasConsentCookie(USER_EXT);
  } else {
    logger(203, 'No euconsent cookie found in local domain.');
    await userNoConsentCookie(USER_EXT);
  }

  /* Hack for Cypress so it knows cmp is done */
  body.setAttribute('data-cy-cmp-done', 'true');
};

/**
 /=============================================================================
 /
 / CMP main block where the fun begins.
 /
 /=============================================================================
 */

// Logs that script is loaded
initSentry();
config(USER_EXT);
start();

window.scmp = {
  open: openExternalImmediately,
  setPublicAPI,
  redirect: () => initRedirect(USER_EXT),
  _redirectDev: () => initRedirect(USER_EXT, true),
  sznCookie: null
};

const autoInit = autoOpen();
logger(204, 'AutoOpen: ' + autoInit);

if (demoMode()) {
  openExternalImmediately();
  logger(205, 'Demo dialog initialization.');
} else if (isStorageEnabled) {
  if (shouldRedirect()) {
    initRedirect(USER_EXT);
  } else if (autoInit && !isWebview(USER_EXT)) {
    initCMP();
    logger(206, 'Automatic dialog initialization.');
  } else {
    logger(207, 'Auto init canceled');
  }
}
